// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1AX5i","header":"Modal_header__2Fg2l","cancel":"Modal_cancel__183jk","yes":"Modal_yes__292CM"};